export default __webpack_public_path__ + "static/media/blue_line.63d5c255.png";